import * as React from 'react'
import Box from '@mui/material/Box'
import Modal from '@mui/material/Modal'
import '../styles/Modal.scss'
import CustomButton from '../components/styled/CustomButton'
import { Button } from '@mui/material'
import { useState } from 'react'
import { getDataById, updateDataById } from '../apis/generalApis'
import { ScaleLoader } from 'react-spinners'
import Swal from 'sweetalert2'

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  maxHeight: '90vh',
  overflow: 'auto',
  transform: 'translate(-50%, -50%)',
  bgcolor: 'background.paper',
  border: 'none',
  boxShadow: '0px 5px 20px #00000040',
  p: 4,
  outline: 'none',
  borderRadius: '16px',
  textAlign: 'center',
}

const AboutMeModal = ({ handleAboutMeModal, aboutMeModal = false }) => {
  const user = JSON.parse(localStorage.getItem('user') || '{}')
  React.useEffect(() => {
    getAboutMe()
  }, [])

  const [aboutMe, setAboutMe] = useState('')
  const [isLoading, setIsLoading] = useState(false)

  const getAboutMe = async () => {
    const result = await getDataById('show-about', { user_id: user?.id })
    if (result?.success === true) {
      setAboutMe(result?.data?.description)
    }
  }

  const updateAboutMe = async () => {
    setIsLoading(true)
    let response = await updateDataById('update-about', {
      user_id: user?.id,
      description: aboutMe,
    })
    if (response.success === true) {
      setIsLoading(false)
      Swal.fire({
        title: 'Success!',
        text: 'About Me Updated Successfully.',
        icon: 'success',
        confirmButtonColor: '#2597F6',
        timer: 3000,
      })
      handleAboutMeModal(false)
    }
  }

  return (
    <>
      <ScaleLoader
        color="#36d7b7"
        loading={isLoading}
        style={{
          position: 'fixed',
          left: 0,
          right: 0,
          height: '100%',
          top: 0,
          display: 'flex',
          zIndex: 1500,
          justifyContent: 'center',
          alignItems: 'center',
          backdropFilter: 'blur(10px)',
          background: '#ffffff00 0% 0% no-repeat padding-box',
        }}
      />
      <Modal
        open={aboutMeModal}
        onClose={() => handleAboutMeModal(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style} className="about-me-modal">
          <div>
            <h3 className="fs-24 fw-bold">About Me</h3>
            <p className="fs-16 mt-3 m-0 font-weight-bold">
              This is what your client see about you
            </p>
            <div className="bordered-text px-2 pt-2 text-left mt-2">
              <textarea
                className="customer-support-message"
                name="about_me"
                cols="30"
                rows="5"
                value={aboutMe}
                onChange={(e) => setAboutMe(e.target.value)}
              ></textarea>
            </div>
            <div className="mt-4">
              {/* <CustomButton title={'Continue'} fullWidth={true} /> */}
              <Button
                className="pointer"
                id="btn-primary-no-shadow"
                fullWidth
                onClick={updateAboutMe}
              >
                Continue
              </Button>
            </div>
          </div>
        </Box>
      </Modal>
    </>
  )
}

export default AboutMeModal
